import {
  endOfQuarter,
  startOfDay,
  startOfMinute,
  startOfQuarter,
  subDays,
  subQuarters,
} from 'date-fns';

import type { MetricRange, RelativePeriod } from '@/shared/types/reports';

export const DEFAULT_RANGE: MetricRange = { kind: 'relative', period: 'last_7_days' };

export const RELATIVE_PERIODS: RelativePeriod[] = [
  'today',
  'last_3_days',
  'last_7_days',
  'last_14_days',
  'last_30_days',
  'last_quarter',
];

export const RELATIVE_PERIOD_I18N_KEY: Record<RelativePeriod, string> = {
  today: 'analytics.reports_detail_range_today',
  last_3_days: 'analytics.reports_detail_range_last_3_days',
  last_7_days: 'analytics.reports_detail_range_last_7_days',
  last_14_days: 'analytics.reports_detail_range_last_14_days',
  last_30_days: 'analytics.reports_detail_range_last_30_days',
  last_quarter: 'analytics.reports_detail_range_last_quarter',
};

export type ResolvedRange = { timeRange: { start: string; end: string } };

const RELATIVE_PERIOD_DAYS: Record<Exclude<RelativePeriod, 'today' | 'last_quarter'>, number> = {
  last_3_days: 3,
  last_7_days: 7,
  last_14_days: 14,
  last_30_days: 30,
};

const resolveRelative = (period: RelativePeriod, now: Date): ResolvedRange => {
  if (period === 'today') {
    return { timeRange: { start: startOfDay(now).toISOString(), end: now.toISOString() } };
  }
  if (period === 'last_quarter') {
    const previous = subQuarters(now, 1);
    return {
      timeRange: {
        start: startOfQuarter(previous).toISOString(),
        end: endOfQuarter(previous).toISOString(),
      },
    };
  }
  const days = RELATIVE_PERIOD_DAYS[period];
  return { timeRange: { start: subDays(now, days).toISOString(), end: now.toISOString() } };
};

export const resolveRange = (range: MetricRange, now: Date = new Date()): ResolvedRange => {
  if (range.kind === 'custom') {
    return { timeRange: { start: range.start, end: range.end } };
  }
  return resolveRelative(range.period, startOfMinute(now));
};
